import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmailPlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEmailPlus"><Path d="M13.5 19.5H2.5V4.5H21.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 5.22729L12 11L2.5 5.22729" stroke="currentColor"/><Path d="M16.5 17.5H22.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 14.5L19.5 20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconEmailPlus;
